// Generated file : do not modify
export enum ConnectionParamModes
{
  NONE = 0,
  CODE,
  PASSWORD,
  CI98,
  DIALOG
};

import User from '@/extend/classes/User';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Interface de connexion
export class LoginParam {
  // Identifiant de connexion
  public identifiant: string;
  // Mot de passe
  public password: string;
  // Mot de passe
  public codeConnection: string;
  // Se souvenir de moi
  public rememberMe: boolean;
  // Le client est un mobile
  public isMobile: boolean;
  // Information sur l'ordinateur connecté
  public userAgent: string;
  // Ip address de l'ordinateur connecté
  public remoteIpAddress: string;
  // Html response
  public html: string;

  constructor() {
    this.identifiant = '';
    this.password = '';
    this.codeConnection = '';
    this.rememberMe = false;
    this.isMobile = false;
    this.userAgent = '';
    this.remoteIpAddress = '';
    this.html = '';
  }
}

export class ConnectionParam {
  // Mode de connexion
  public mode: ConnectionParamModes;
  // Mot de passe
  public password: string;
  // Information sur l'ordinateur connecté
  public userAgent: string;

  constructor() {
    this.mode = ConnectionParamModes.NONE;
    this.password = '';
    this.userAgent = '';
  }
}

export class LoginAnswer {
  // Mode de connexion
  public mode: ConnectionParamModes;
  // utilisateur connecté
  public user: User | null;
  // Token de connexion
  public token: string;
  // Html response
  public html: string;
  // Compte bloqué DOM-TOM
  public isDomtom: boolean;
  // Connecter en sudo
  public isSudo: boolean;
  // Compte désactivé
  public accountDisabled: boolean;

  constructor() {
    this.mode = ConnectionParamModes.NONE;
    this.user = null;
    this.token = '';
    this.html = '';
    this.isDomtom = false;
    this.isSudo = false;
    this.accountDisabled = false;
  }
}

